import moment from 'moment'
import React, { useState } from 'react'
import { Icon, Image, Input, InputOnChangeData, Label, Popup, Table } from 'semantic-ui-react'
import calendar from '../../../../assets/svg/calendar.svg'
import completed from '../../../../assets/svg/completed_label.svg'
import progress from '../../../../assets/svg/in_progress_label.svg'
import search from '../../../../assets/svg/search_icon.svg'
import upcoming from '../../../../assets/svg/upcoming_label.svg'
import CircularLabel from '../../../../components/Labels/CircularLabel'
import { _MIXEDCOLORS } from '../../../../constants/colors'
import { createInitials } from '../../../../utils/createInitials'
import { IEmployee } from '../../../settings/types/employee'
import { ICostHistory } from '../../types/directAndPassTroughCosts'
import { IProjectActivityHistory } from '../../types/projectActivity'
import './ActivityDetails.css'

interface Props {
  history: (IProjectActivityHistory | ICostHistory)[]
  filterHistory: (searchQuery: string) => void
}

const _header = [
  { text: 'Date', padding: '6px 0 6px 12px', width: '90px' },
  { text: 'Activity', padding: '6px 0 6px 6px', width: '210px' },
  { text: 'Member', padding: '6px 0 6px 6px', width: '100%' }
]

const ActivityDetailsLogsComponent = (props: Props): JSX.Element => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchLoading, setSearchLoading] = useState(false)
  const [timer, setTimer] = useState<number>(0)

  const renderTableHeader = () => {
    return _header.map((h, idx) => {
      return (
        <Table.HeaderCell key={idx} style={{ padding: h.padding, color: '#747678', border: 'none',minWidth: h.width, maxWidth: h.width, width: h.width }}>{h.text}</Table.HeaderCell>
      )
    })
  }

  const renderImage = (employee: IEmployee) => {
    const randColor = Math.floor((Math.random() * (_MIXEDCOLORS.length - 1) + 1))
    return employee?.photo ?
    <Image
      circular={true}
      style={{
        display: 'initial',
        margin: '-.2rem .2rem 0 .2rem',
        maxWidth: `calc(1.5rem - 2px)`,
        maxHeight: `calc(1.5rem - 2px)`,
        minWidth: `calc(1.5rem - 2px)`,
        minHeight: `calc(1.5rem - 2px)`,
        objectFit: 'cover'
      }}
      src={employee.photo}
      /> : <CircularLabel
      content={createInitials(employee)}
      color={_MIXEDCOLORS[randColor]}
      style={{
        fontSize: '.7rem',
        margin: '-.2rem .2rem 0 .2rem',
      }}
      height='calc(1.5rem - 2px)'
      width='calc(1.5rem - 2px)'
    />
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    clearTimeout(timer)
    const _timer = window.setTimeout(() => {
      setSearchLoading(false)
    }, 300)
    setTimer(_timer)
    setSearchLoading(true)
    setSearchQuery(data.value)
    let _dataValue = data.value
    const _todaysDate = new Date()
    const _year = _todaysDate.getFullYear().toString()
    const _month = (_todaysDate.getMonth() + 1).toString()
    const _validMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const getMonth = (month: string) => {
      return _validMonths.includes(month) ? (_validMonths.findIndex((val) => val === month) + 1).toString() : _month
    }
    if (_dataValue.includes('/')) {
      const _splitedDate = _dataValue.split('/')
      if (_splitedDate.length === 2 ) {
        if (_splitedDate[1] === '' && !_validMonths.includes(_splitedDate[0])) {
          _dataValue = moment(_year + '-' + _month + '-' + _splitedDate[0]).format('YYYY-MM-DD')
        } else {
          if (_validMonths.includes(_splitedDate[0]) && _splitedDate[1] === '') {
            const _justMonth = getMonth(_dataValue)
            _dataValue = moment(_year + '-' + _justMonth).format('YYYY-MM')
          } else {
            if (_validMonths.includes(_splitedDate[0])) {
              const _monthTyped = getMonth(_splitedDate[0])
              _dataValue = moment(_splitedDate[1] + '-' + _monthTyped).format('YYYY-MM')
            } else {
              const _monthTyped = getMonth(_splitedDate[1])
              _dataValue = moment(
                  _year + '-' + _monthTyped + '-' + _splitedDate[0]
                ).format('YYYY-MM-DD')
            }
          }
        }
      }
      if (_splitedDate.length === 3 ) {
        if (_splitedDate[2] === '') {
          const _monthTyped = getMonth(_splitedDate[1])
          _dataValue = moment(
            _year + '-' + _monthTyped + '-' + _splitedDate[0]
            ).format('YYYY-MM-DD')
        } else {
          _dataValue = moment(
            _splitedDate[2] + '-' + getMonth(_splitedDate[1]) + '-' + _splitedDate[0]
            ).format('YYYY-MM-DD')
        }
      }
    } else {
      if (_validMonths.includes(_dataValue)) {
        const _justMonth = getMonth(_dataValue)
        _dataValue = moment(_year + '-' + _justMonth).format('YYYY-MM')
      }
    }

    if (!_dataValue.includes('/') && _validMonths.includes(_dataValue)) {
      const _justMonth = getMonth(_dataValue)
      _dataValue = moment(_year + '-' + _justMonth).format('YYYY-MM')
    }
    props.filterHistory(_dataValue)
  }

  const handleClearSearch = () => {
    setSearchQuery('')
  }

  const renderSearchIcon = () => {
    if (searchQuery === '') {
      return <Image src={search} style={{ left: '-95%' }} />
    }
    return <Icon name='close' link={true} onClick={handleClearSearch} />
  }

  const dateAction = (entry: IProjectActivityHistory) => {
    const textBefore = 'Changed '
    const content = <Image src={calendar} style={{ height: '1rem', marginLeft: '0.5rem' }} />
    return (
      <div style={{ display: 'flex', flexDirection: 'column', fontSize: '1rem' }}>
        <div style={{ display: 'flex', marginBottom: '0.2rem' }}>{textBefore}{content}</div>
        <div style={{ display: 'flex', marginBottom: '0.2rem' }}>
          from
          <p style={{ padding: '0.1rem', borderRadius: '0.2rem', background: '#F3F3F3', marginLeft: '0.5rem' }}>
            {entry.last_start_date ? moment(entry.last_start_date).format('DD/MMM/YY') : ''} - {entry.last_end_date ? moment(entry.last_end_date).format('DD/MMM/YY') : ''}
          </p>
        </div>
        <div style={{ display: 'flex' }}>
          to
          <p style={{ padding: '0.1rem', borderRadius: '0.2rem', background: '#F3F3F3', marginLeft: '0.5rem' }}>
            {entry.start_date ?  moment(entry.start_date).format('DD/MMM/YY') : ''} - {entry.end_date ? moment(entry.end_date).format('DD/MMM/YY') : ''}
          </p>
        </div>
      </div>
    )
  }

  const employeeAction = (entry: IProjectActivityHistory) => {
    let textBefore = ''
    if (entry.employee) {
      if (entry.history_change_reason.startsWith('added')) {
        textBefore = 'Added '
      } else {
        textBefore = 'Removed '
      }

      return (
         <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          whiteSpace: 'break-spaces'
         }}>{textBefore}{renderImage(entry.employee)}<strong style={{marginLeft: '2px'}}>{entry.employee.full_name}</strong> as a <strong>team member</strong>.</div>
      )
    }
    return null
  }

  const labelAction = (entry: IProjectActivityHistory) => {
    let textBefore = ''
    if (entry.label) {
      if (entry.history_change_reason.startsWith('label_added')) {
        textBefore = 'Added Label '
      } else {
        textBefore = 'Removed Label '
      }

      return (
        <div style={{ display: 'flex', fontSize: '1rem', width: '15rem', }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>{textBefore} <Label
            style={{
              fontSize: '1rem',
              letterSpacing: '.25px',
              fontWeight: 500,
              background: entry.label.color,
              color: '#172533',
              borderRadius: '5px',
              height: '1.5rem',
              padding: '3px 5px 0 4px'
            }}
              >
            <Icon name='hashtag' style={{ cursor: 'default', fontSize: '0.8rem', letterSpacing: '.25px', fontWeight: 500, color: '#172533', marginRight: '0.2rem'}}/>{entry.label.name}
          </Label> to the task.</div>
          </div>
        </div>
      )
    }
    return null
  }

  const changeStatus = (entry: IProjectActivityHistory) => {
    let statusText = ''
    if (entry.history_change_reason.startsWith('status_changed')) {
      if (entry.status === 'completed') {
        statusText = 'Completed'
      } else if (entry.status === 'in_progress') {
        statusText = 'In Progress'
      } else {
        statusText = 'Upcoming'
      }
    }
    return (
      <div style={{ display: 'flex', fontSize: '1rem', width: '15rem', }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          Project Status changed to
          <Label
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              height: '26px',
              width: 'max-content',
              borderRadius: '8px',
              background:
                entry.status === 'completed' ? 'rgba(65, 133, 255, 0.2)' :
                  entry.status === 'in_progress' ? 'rgba(255, 190, 65, 0.2)' :
                    entry.status === 'upcoming' ? 'rgba(146, 146, 146, 0.2)' : '#F3F3F3',
              color:
                entry.status === 'completed' ? '#4185FF' :
                  entry.status === 'in_progress' ? '#FFBE41' :
                    entry.status === 'upcoming' ? '#929292' : '#F3F3F3',
            }}>
            <Image
              src={
                entry.status === 'completed' ? completed :
                  entry.status === 'in_progress' ? progress :
                    entry.status === 'upcoming' ? upcoming : undefined
              }
              style={{ maxWidth: '12px', marginRight: '5px' }} />
            {statusText}
          </Label>
        </div>
      </div>
    )
  }

  const renderTableBody = () => {
    return props.history.map((entry) => {
      return (
        <Table.Row style={{ display: 'table', width: '100%', tableLayout: 'inherit' }} key={entry.history_id}>
          <Table.Cell verticalAlign='top' style={{ padding: '14px 0 14px 12px', fontSize: '14px', fontWeight: 600, width: '90px' }}>{moment(entry.history_date).format('DD/MM/YYYY')}</Table.Cell>
          <Table.Cell verticalAlign='top' style={{ fontSize: '14px', color: '#172533', letterSpacing: '.25px', padding: '14px 0 14px 6px', width: '210px' }}>
            {entry.history_change_reason.startsWith('date') ? dateAction(entry) : entry.history_change_reason.startsWith('label') ? labelAction(entry) : entry.history_change_reason.startsWith('status_changed') ? changeStatus(entry) : employeeAction(entry) }
          </Table.Cell>
          <Table.Cell verticalAlign='top' style={{ fontSize: '14px', color: '#172533', letterSpacing: '.25px', padding: '14px 0 14px 6px', fontWeight: 'bold', width: 'auto' }}>{entry.status !== 'in_progress' ? `by ${entry.user}` : ''}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '0 32px', marginTop: '-20px' }}>
      <div>
        <Popup
          className='popup-info'
          trigger={<Icon name='info circle' size='small' style={{ position: 'relative', top: '26px', left: '220px', zIndex: '9999' }} />}
          content='Valid date search in DD/MMM/YYYY format ie. 24/May/2021. Only month search in MMM format, ie. May.'
          position='left center'
        />
        <Input loading={searchLoading} value={searchQuery} className='search-input-medium' size='small' style={{ width: '500px' }} icon={renderSearchIcon()} iconPosition='left' placeholder='Search' onChange={handleSearch} />
      </div>
    <Table basic='very'>
      <Table.Header style={{ height: '40px', backgroundColor: '#F4F7F9', display: 'table', tableLayout: 'inherit' }}>
        <Table.Row>
          {renderTableHeader()}
        </Table.Row>
      </Table.Header>
      <Table.Body style={{ display: 'block', height: 'calc(100vh - 342px)', overflow: 'hidden auto' }}>{renderTableBody()}</Table.Body>
    </Table>
    </div>
  )
}

export default ActivityDetailsLogsComponent
